import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20">
        <h1 className="text-8xl md:text-[10rem] font-black text-background-200 select-none pointer-events-none z-0 font-heading leading-none">
          404
        </h1>
        <div className="relative z-10 -mt-12">
          <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900 font-heading">Page Not Found</h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-sm md:text-base text-foreground-400 max-w-md mx-auto">
            The page you are looking for does not exist or has been moved. Please check the URL or return to the homepage.
          </p>
          <a 
            href="/" 
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line w-4 h-4 flex items-center justify-center" />
            Back to Home
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}